export default __webpack_public_path__ + "static/media/android.aca02ce7.png";